/*
 * Aurala pixel gate
 * Suppresses Meta pixel (`fbq`) events when the page is being viewed in a
 * non-production context. Without this, dev/preview/Playwright/CDP sessions
 * fire AddToCart + InitiateCheckout into the live pixel and pollute Meta's
 * audience optimisation for paid campaigns.
 *
 * Usage in theme JS:
 *   if (window.AuralaPixelGate && window.AuralaPixelGate.allow()) {
 *     window.fbq('track', 'AddToCart', {...});
 *   }
 *
 * Manual escape hatches (for operator use):
 *   ?nopixel=1                                       — one-shot suppression via URL
 *   localStorage.setItem('aurala_nopixel', '1')      — persistent suppression
 *   localStorage.setItem('aurala_pixel_off', '1')    — persistent suppression (alias, easier to type)
 *
 * To suppress your normal-browser test traffic so it stops polluting the live Meta pixel:
 *   1. Open https://auralanaturals.com in your normal browser
 *   2. Open devtools console (F12 then Console tab)
 *   3. Paste: localStorage.setItem('aurala_pixel_off', '1')
 *   4. Verify: window.AuralaPixelGate.reason()  // should return "localStorage.aurala_pixel_off"
 */
(function () {
  var LIVE_HOST = 'auralanaturals.com';

  function safeLocalStorageGet(key) {
    try { return window.localStorage && localStorage.getItem(key); } catch (e) { return null; }
  }

  function reason() {
    // 1. Shopify theme preview
    if (location.search && location.search.indexOf('preview_theme_id=') !== -1) {
      return 'preview_theme_id';
    }
    // 2. Wrong host (myshopify.com, staging, localhost, etc.)
    if (location.hostname !== LIVE_HOST) {
      return 'non_live_host:' + location.hostname;
    }
    // 3. Automation (Playwright, headless Chrome, Selenium)
    if (navigator.webdriver === true) {
      return 'navigator.webdriver';
    }
    // 4. Manual URL opt-out
    if (location.search && location.search.indexOf('nopixel=1') !== -1) {
      return 'nopixel=1';
    }
    // 5. Persistent operator opt-out
    if (safeLocalStorageGet('aurala_nopixel') === '1') {
      return 'localStorage.aurala_nopixel';
    }
    if (safeLocalStorageGet('aurala_pixel_off') === '1') {
      return 'localStorage.aurala_pixel_off';
    }
    return null;
  }

  window.AuralaPixelGate = {
    allow: function () { return reason() === null; },
    reason: reason,  // exposed for debugging in DevTools
  };
})();
